import React from 'react'
import { useStyles } from './styles'
import { Box } from '@material-ui/core'
import { INPROGRESS, SUCCESS, ERROR } from '../constants'
import EnphaseLogo from '../EnphaseLogo/EnphaseLogo'
const Header = (props) => {
  const classes = useStyles()
  const { headerState } = props
  return (
    <>
      <Box className={classes.heatLoanFormEnphaseLogoBox}>
        <EnphaseLogo></EnphaseLogo>
      </Box>
      {headerState === INPROGRESS ? (
        <Box className={classes.heatLoanFormHeader}>
          <Box className={classes.heatLoanFormTitle}>
            Heat Loan Form - Enphase Energy
          </Box>
          <Box className={classes.heatLoanFormDescription}>
            This form is to be filled by installers in MA, CT and RI region; on
            behalf of homeowners who want to apply for heat loan program and
            ConnectedSolutions program while purchasing Enphase storage system.
          </Box>
        </Box>
      ) : headerState === SUCCESS ? (
        <Box className={classes.heatLoanFormHeader}>
          <Box className={classes.heatLoanFormTitle}>
            Hey, Your Response is recorded. Thanks!
          </Box>
          <Box className={classes.heatLoanFormDescription}>
            You are set to fill in a new heat loan form for a home owner.
          </Box>
        </Box>
      ) : (
        <Box className={classes.heatLoanFormHeader}>
          <Box className={classes.heatLoanFormTitle}>Something Went Wrong</Box>
          <Box className={classes.heatLoanFormDescription}>
            Thanks for your valuable time! Try after some time.
          </Box>
        </Box>
      )}
    </>
  )
}
export default Header
